import React, { useEffect } from 'react';
import Tab from '../../Components/Tab/Tab';
import './Jungsan.scss';
import JungsanInfo from './JungsanInfo/JungsanInfo';
import ReqJungsan from './ReqJungsan/ReqJungsan';

const routeList = {
    'jungsan-info': '정산정보',
    'jungsan' : '정산하기'
}

const Jungsan = (props) => {
    const [ name, setName ] = React.useState('jungsan')
    
    const tabRoute = [
        { route : 'jungsan', header : '정산하기' },
        { route : 'jungsan-info', header : '정산정보' },
    ]

    return (
        <div className='wrapper'>
            <div className='header-row'>
                <p className='header-text'>정산 {'>'}</p>
                <p className='header'>{routeList[name]}</p>
            </div>
            <Tab 
                routes={tabRoute}
                current={name}
                onTabChange={(name) => setName(name)}
                renderItems={{
                    'jungsan' : <ReqJungsan />,
                    'jungsan-info' : <JungsanInfo />,
                }}
            />
        </div>
    )
}

export default Jungsan;